import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { useGetSubcategoryList } from '@/features/configuration-management/charge-management/category/hooks/useGetSubcategoryList';
import { ChargeWithdrawalCategoryTable } from '@/features/configuration-management/charge-management/category/table';
import { PercentageIcon } from '@/icons';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['categoryType', 'description', 'createdDate', 'status']),
  desc: z.boolean(),
});

const CategorySearchSchema = z.object({
  breadcrumbReturnTo: z.string().optional(),
  activeTab: z.enum(['affiliate', 'club', 'customer']).optional(),

  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),
  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
  agentType: z.coerce.string().optional(),
  q: z
    .any()
    .optional()
    .transform((val) => (val == null ? undefined : String(val))),
  createdDate: z.string().optional(),
});

export const Route = createFileRoute('/(app)/configuration-management/charges/$categoryId/')({
  component: RouteComponent,
  loader: () => ({
    crumb: <CrumbTitle id="configurationManagement.charges.chargeSubCategory.crumb.category" icon={PercentageIcon} />,
  }),
  validateSearch: (search: SearchSchemaInput) => CategorySearchSchema.parse(search),
});

function RouteComponent() {
  const { categoryId } = Route.useParams();
  const { data, meta, isLoading } = useGetSubcategoryList({ categoryId: categoryId });
  return <ChargeWithdrawalCategoryTable data={data} pagination={meta} isLoading={isLoading} />;
}
